/**
 * Writes the filters held under plain names into an address, as `filter[name]`.
 *
 * A name with one value keeps the plain form every link and saved view
 * already carries. A name with several takes the list form: repeated in the
 * plain form, the endpoint answers on the last value alone, so "Erfasst +
 * Läuft" silently filtered on "Läuft" (#2340).
 */
export const appendFilterParams = (target: URLSearchParams, filters: [string, string][]): void => {
    const byName = new Map<string, string[]>();

    filters.forEach(([name, value]) => byName.set(name, [...(byName.get(name) ?? []), value]));

    byName.forEach((values, name) =>
        1 === values.length
            ? target.append(`filter[${name}]`, values[0])
            : values.forEach(value => target.append(`filter[${name}][]`, value))
    );
};
